import { Company } from './company.model';

export class GetDataDashboardResponse {
  companies: Company[];

  constructor(companies: Company[]) {
    this.companies = companies;
  }
}
